export default "__VITE_ASSET__B41n$VCT__"